import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as BackstageConstants from '../../../constants';
import { withArtistButtonControls } from '../../common/ArtistButtonControls';
import ListenerCountSubtitleLarge from '../../common/ListenerCountSubtitleLarge';
import LayoutManager from '../../layout/LayoutManager';
import ArtistSidebarButtons from '../BackstageArtist1/ArtistSidebarButtons';

import ArtistLargeHeader from './ArtistLargeHeader';
import ArtistMainContent from './ArtistMainContent';

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
export const BackstageArtistContent = props => {
  const {
    albumCount,
    artistEvents,
    artistPlayId,
    artUrl,
    bio,
    children,
    curatedPlaylists,
    curatedStations,
    featuredContent,
    hasCuratorPrograms,
    hasRadio,
    headerArtUrl,
    isArtistTopSongsPlaying,
    isMegastar,
    isMobileWeb,
    isLoaded,
    isRightRailActive,
    largeHeaderDominantColor,
    largeHeaderUrl,
    latestRelease,
    latestReleaseArtUrl,
    name,
    pandoraId,
    pauseTopSongs,
    playArtistStation,
    playTopSongs,
    shareArtist,
    similarArtists,
    stationListenerCount,
    topAlbums,
    topSongsHaveNoRights,
    topSongsIsDisabled,
    topSongsLooksDisabled,
    topTracks,
    twitterUrl,
    urlPath,
  } = props;

  const artistLargeHeaderProps = {
    isArtistTopSongsPlaying,
    largeHeaderDominantColor,
    largeHeaderUrl,
    name,
    pauseTopSongs,
    playTopSongs,
    stationListenerCount,
    topSongsIsDisabled,
    topSongsLooksDisabled,
  };

  const sidebarButtonsProps = {
    hasRadio,
    isArtistTopSongsPlaying,
    artistName: name,
    pauseTopSongs,
    playArtistStation,
    playTopSongs,
    shareArtist,
    topSongsHaveNoRights,
  };

  const hasLargeHeader = isMegastar && largeHeaderUrl;

  const mainContentProps = {
    aboutBackgroundImageUrl: headerArtUrl || latestReleaseArtUrl,
    albumCount,
    artistName: name,
    artistPlayId,
    bio,
    curatedPlaylists,
    curatedStations,
    featuredContent,
    hasArtistEvents: artistEvents?.length > 0,
    hasLargeHeader,
    hasRadio,
    isMegastar,
    isMobileWeb,
    isRightRailActive,
    latestRelease,
    pandoraId,
    shareableUrlPath: urlPath,
    similarArtists,
    topAlbums,
    topTracks,
    twitterUrl,
  };

  const childrenProps = {
    description: bio,
    descriptionTitle: <FormattedMessage {...BackstageConstants.messages.about} />,
    hasLargeHeader,
    ...props,
  };

  return (
    <LayoutManager
      hasCuratorPrograms={hasCuratorPrograms}
      heroImageUrl={artUrl}
      isHeaderInSidebar={true}
      isMobileDevice={isMobileWeb}
      largeHeader={hasLargeHeader && <ArtistLargeHeader {...artistLargeHeaderProps} />}
      mainContent={
        children ? (
          React.cloneElement(children, childrenProps)
        ) : (
          <ArtistMainContent {...mainContentProps} />
        )
      }
      name={name}
      // pandoraId only gets passed once the full data has been loaded to prevent duplicate events due to a change in hasCuratorPrograms
      pandoraId={isLoaded && pandoraId}
      shareableUrlPath={urlPath}
      sidebarButtons={!isMobileWeb && <ArtistSidebarButtons {...sidebarButtonsProps} />}
      subTitleLrg={<ListenerCountSubtitleLarge stationListenerCount={stationListenerCount} />}
    />
  );
};

BackstageArtistContent.propTypes = {
  albumCount: PropTypes,
  artistEvents: PropTypes.string,
  artistPlayId: PropTypes.string,
  artistTracksId: PropTypes.string,
  artUrl: PropTypes.string,
  bio: PropTypes.string,
  children: PropTypes.element,
  curatedPlaylists: PropTypes.array,
  curatedStations: PropTypes.array,
  featuredContent: PropTypes.array,
  hasCuratorPrograms: PropTypes.bool,
  hasRadio: PropTypes.bool,
  headerArtUrl: PropTypes.string,
  isArtistTopSongsPlaying: PropTypes.bool,
  isLoaded: PropTypes.bool,
  isMegastar: PropTypes.bool,
  isMobileWeb: PropTypes.bool,
  isRightRailActive: PropTypes.bool,
  largeHeaderDominantColor: PropTypes.string,
  largeHeaderUrl: PropTypes.string,
  latestRelease: PropTypes.object,
  latestReleaseArtUrl: PropTypes.string,
  name: PropTypes.string,
  pandoraId: PropTypes.string,
  pauseTopSongs: PropTypes.func,
  playArtistStation: PropTypes.func,
  playTopSongs: PropTypes.func,
  shareArtist: PropTypes.func,
  similarArtists: PropTypes.array,
  stationListenerCount: PropTypes.number,
  topAlbums: PropTypes.array,
  topSongsHaveNoRights: PropTypes.bool,
  topSongsIsDisabled: PropTypes.bool,
  topSongsLooksDisabled: PropTypes.bool,
  topTracks: PropTypes.array,
  twitterUrl: PropTypes.string,
  urlPath: PropTypes.string,
};

// @ts-expect-error will be fixed with WEBCA-2925
export default withArtistButtonControls(BackstageArtistContent);
